export const orderRates = [
  {
    currency: "USD",
    title: "美元",
    value: "",
    status: "up",
    statusStr: "USD_Current",
  },
  {
    currency: "HKD",
    title: "港币",
    value: "",
    status: "up",
    statusStr: "HKD_Current",
  },
  {
    currency: "EUR",
    title: "欧元",
    value: "",
    status: "up",
    statusStr: "EUR_Current",
  },
  // {
  //   currency: "GBP",
  //   title: "英镑",
  //   value: "",
  //   status: "up",
  //   statusStr: "GBP_Current",
  // },
];

export const customsRates = [
  {
    currency: "USD",
    title: "美元",
    value: "",
    status: "up",
    statusStr: "USD_Current",
  },
  {
    currency: "HKD",
    title: "港币",
    value: "",
    status: "up",
    statusStr: "HKD_Current",
  },
  {
    currency: "EUR",
    title: "欧元",
    value: "",
    status: "up",
    statusStr: "EUR_Current",
  },
  {
    currency: "GBP",
    title: "英镑",
    value: "",
    status: "up",
    statusStr: "GBP_Current",
  },
];

export const homeOneData = [
  {
    title: "订单管理",
    className: "c-ff583f iconfont icon-dingdan c-home-icon",
    routeName: "orderList",
  },
  {
    title: "财务管理",
    className: "c-00bbab iconfont icon-caiwu c-home-icon",
    routeName: "finance",
  },
  {
    title: "产品中心",
    className: "c-44b600 iconfont icon-chanpinzhongxin c-home-icon",
    routeName: "productCenter",
  },
];

export const homeTwoData = [
  {
    title: "库存管理",
    className: "c-ff9100 iconfont  icon-kucunguanli1 c-home-icon",
    routeName: "stockMessage",
  },
  {
    title: "OCR理货",
    svg: "camera-yellow",
    //className: "c-247be3 iconfont icon-kehuzhongxin2 c-home-icon",
    routeName: "ocr-order-list",
  },
  {
    title: "费用计算器",
    className: "c-6f24ca iconfont icon-calc c-home-icon",
    routeName: "calc",
  },
];
